import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const ViewData = styled(Box)`
  position: absolute;
  top: 317px;
  left: 169px;
  background: ${theme.colors.primaryLight};
  border-radius: 0 0 ${theme.attributes.borderRadius.small} ${theme.attributes.borderRadius.small};
  z-index: 10000;
  width: 420px;
  height: 56px;
  padding: ${theme.spacing.xSmall}px ${theme.spacing.md}px;
  justify-content: flex-end;
  align-items: center;
  display: none;
  transition: opacity 313ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 208ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &.isopen {
    display: flex;
  }

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
    box-shadow: ${theme.colors.tooltipShadow};

    .MuiButtonBase-root {
      color: ${theme.colors.cta} !important;
      background: transparent !important;

      &.Mui-disabled {
        color: ${theme.colors.calendarDisabledDay} !important;
      }
    }
  }
`

export const viewDataStyles = {
  borderColor: 'transparent !important',
  background: 'rgba(208, 188, 255, 0.08) !important',

  '&:hover': {
    background: 'rgba(208, 188, 255, 0.04) !important'
  }
}
